export function hamburgerNavigationToggler() {
    $('.hamburger-menu-btn').click(function () {
        $('.hamburger-nav-container').toggleClass('show')
    })
}

export function activeNavToggler() {
    $('.nav a').filter(function () { 
        return this.href == location.href })
        .parent().addClass('active').siblings().removeClass('active')
    
    $('.nav a').click(function () {
        $(this).parent().addClass('active').siblings().removeClass('active')
    })
}

export function activeNavOnDropdownHover() {
    $(".header-dropdown").hover(function() {
        $(this).parent().addClass("dropdown-opened");
    }, function() {
        $(this).parent().removeClass("dropdown-opened");
    });
}

export function headerDropdownSupplements() {
    if (window.location.hash === '#supplements') {
        $('#nav-tab a:nth-of-type(2)').trigger('click');
    }
}

export function onLoadSupplements() {
    let activeTab = sessionStorage.getItem('activeTab')

    if(activeTab === 'supplements') {
        $('.medications-tab').removeClass('active show')
        $('.supplements-tab').addClass('active show')

        sessionStorage.removeItem('activeTab')
    }
}

